import script from "./FoundErrorModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./FoundErrorModal.vue?vue&type=script&setup=true&lang=ts"

import "./FoundErrorModal.vue?vue&type=style&index=0&id=c65bcb10&scoped=true&lang=css"
import "./FoundErrorModal.vue?vue&type=style&index=1&id=c65bcb10&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c65bcb10"]])

export default __exports__